import { render } from "./House.vue?vue&type=template&id=2510bc5c"
import script from "./House.vue?vue&type=script&lang=js"
export * from "./House.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/House.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2510bc5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2510bc5c', __exports__)) {
    api.reload('2510bc5c', __exports__)
  }
  
  module.hot.accept("./House.vue?vue&type=template&id=2510bc5c", () => {
    api.rerender('2510bc5c', render)
  })

}


export default __exports__